import { useState, useRef } from 'react';

import { ReactComponent as ColumnsIcon } from 'assets/icons/view-column.svg';
import { Switch } from 'components/Bool/Bools.style';
import { useOnClickOutside } from 'hooks/useOnClickOutside';

import { CheckMenuWrapper, IconWrapper } from './TableNav.style';

type Props = {
  columns: any[];
  length: number;
  setSortBy?: (rules: any[]) => void;
  sortBy?: any[];
};

export function ColumnFilters({ columns, length, setSortBy, sortBy }: Props) {
  const ref = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);
  useOnClickOutside(ref, () => setMenuOpen(false));

  const canOrderBy = Boolean(setSortBy);
  // Only real, user-facing data columns are sortable.
  const sortableColumns = columns.filter(
    (column) =>
      column.canSort !== false && typeof column.Header === 'string' && column.Header,
  );
  const activeSort = sortBy?.[0];
  const activeSortId = activeSort?.id ?? '';
  const isDesc = Boolean(activeSort?.desc);

  const handleFieldChange = (id: string) => {
    if (!setSortBy) return;
    if (!id) return setSortBy([]);
    setSortBy([{ id, desc: isDesc }]);
  };

  const handleDirectionChange = (desc: boolean) => {
    if (!setSortBy || !activeSortId) return;
    setSortBy([{ id: activeSortId, desc }]);
  };

  return (
    <IconWrapper ref={ref} disabled={length === 0}>
      <div className='viewActionBtn' onClick={() => setMenuOpen((current) => !current)}>
        <ColumnsIcon />
        <p className='view-text'>View</p>
      </div>
      {(() => {
        if (!menuOpen) return null;
        return (
          <CheckMenuWrapper>
            {canOrderBy && (
              <li className='orderByBlock'>
                <span>Order by:</span>
                <select
                  className='orderBySelect'
                  value={activeSortId}
                  onChange={(e) => handleFieldChange(e.target.value)}
                >
                  <option value=''>None</option>
                  {sortableColumns.map((column) => (
                    <option key={column.id} value={column.id}>
                      {column.Header}
                    </option>
                  ))}
                </select>
                <div className='orderByDirection'>
                  <button
                    type='button'
                    className={!isDesc ? 'active' : ''}
                    disabled={!activeSortId}
                    onClick={() => handleDirectionChange(false)}
                  >
                    Asc
                  </button>
                  <button
                    type='button'
                    className={isDesc ? 'active' : ''}
                    disabled={!activeSortId}
                    onClick={() => handleDirectionChange(true)}
                  >
                    Desc
                  </button>
                </div>
              </li>
            )}
            <span>Select Columns:</span>
            {columns.map((column) => (
              <li key={column.id}>
                <Switch
                  height='2rem'
                  width='4rem'
                  type='checkbox'
                  {...column.getToggleHiddenProps()}
                />
                <label style={{ marginLeft: '1.5rem' }}>{column.Header}</label>
              </li>
            ))}
          </CheckMenuWrapper>
        );
      })()}
    </IconWrapper>
  );
}
